import React, { useEffect } from "react";
import { HubMaterialHookSelect } from "../../components";
import { useFormContext } from "react-hook-form";
import { useGetMaterialCost } from "../../hooks";
import { setIsOpenDialog } from "../../redux";
import { connect } from "react-redux";

const ItemDescriptionMaterial = ({
  prefix,
  disabled,
  _setIsOpenDialog = () => {},
  ...rest
}) => {
  const { watch, setValue } = useFormContext();
  const customerId = watch("customerId");
  const materialId = watch(`${prefix}.materialId`);

  const { data: price, isSuccess } = useGetMaterialCost({
    customerId,
    materialId,
  });

  useEffect(() => {
    if (isSuccess) setValue(`${prefix}.price`, price || 0);
  }, [isSuccess, price]);

  const onCreateMaterial = (data) => {
    setValue(`${prefix}.materialId`, data?.id);
  };

  const onEmptySelect = (defaultValue) => {
    _setIsOpenDialog("create-material", {
      onSuccess: onCreateMaterial,
      defaultValue,
    });
  };

  const emptyOption = {
    label: "Create New Material",
    onSelect: onEmptySelect,
  };

  return (
    <HubMaterialHookSelect
      name={`${prefix}.materialId`}
      formControlProps={{ className: "LineItemDescription" }}
      emptyOption={emptyOption}
      disabled={disabled}
      useDefault={false}
      enableSearch
      hideLabel
      required
      {...rest}
    />
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemDescriptionMaterial);
